import { styled } from '@mui/material/styles';
import { Chip, ChipProps } from '@mui/material';
import { StyledComponent } from '@emotion/styled';
import { Colors } from '../../../constants';
import { CloseIcon } from '../../../icons';

export const CoreAutocompleteChip: StyledComponent<ChipProps> = styled((props: ChipProps) => (
	<Chip {...props} deleteIcon={<CloseIcon width={18} height={18} />} />
))(({ theme }) => ({
	paddingRight: 7,
	backgroundColor: Colors.transparent,
	border: `1px solid ${Colors.white_a20}`,
	borderRadius: '100px',

	'& .MuiChip-deleteIcon': {
		minWidth: 16,
		color: Colors.white,

		'&:hover': {
			color: Colors.gray,
		},
	},

	'& .MuiChip-icon': {
		marginLeft: '12px',
		marginRight: '-4px !important',
	},

	'& .MuiChip-label': {
		// ...theme.typography.label,
		color: Colors.white,
		fontFamily: 'Montserrat, sans-serif',
		fontSize: 14,
		fontWeight: 500,
		lineHeight: '21px',
	},
}));
